'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'circles-overlap';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e600';
var svgPathData = ['M213.4 383.7c10.9 23.1 25.7 44 43.4 62c-10.7 1.6-21.7 2.4-32.8 2.4C100.3 448 0 347.7 0 224S100.3 0 224 0c62.3 0 118.6 25.4 159.2 66.4C393.9 64.8 404.8 64 416 64c123.7 0 224 100.3 224 224s-100.3 224-224 224c-62.3 0-118.6-25.4-159.2-66.4c25.6-3.8 49.8-11.9 71.8-23.5C353.8 438.5 383.8 448 416 448c88.4 0 160-71.6 160-160c0-84.8-66-154.2-149.4-159.7c-10.9-23.1-25.7-44-43.4-62c-25.6 3.8-49.8 11.9-71.8 23.5C286.2 73.5 256.2 64 224 64C135.6 64 64 135.6 64 224c0 84.8 66 154.2 149.4 159.7z', 'M256.8 445.6C365 429.7 448 336.6 448 224c0-61.5-24.8-117.1-64.8-157.6C275 82.3 192 175.4 192 288c0 61.5 24.8 117.1 64.8 157.6z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCirclesOverlap = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;